/* Angular Component */
import { Component } from "@angular/core";

@Component({
  selector: "not-found",
  templateUrl: "./notFound.component.html",
  styleUrls: ["./notFound.component.scss"],
})
export class NotFoundComponent {
  appName = "Page Not Found";
}
